const slideLoaders = {
  TitleCover: () => import('./slides/TitleCoverSlide.vue'),
  SectionDivider: () => import('./slides/SectionDividerSlide.vue'),
  KeyMetric: () => import('./slides/KeyMetricSlide.vue'),
  StatGrid: () => import('./slides/StatGridSlide.vue'),
  ChartWithCallouts: () => import('./slides/ChartWithCalloutsSlide.vue'),
  HighlightsGrid: () => import('./slides/HighlightsGridSlide.vue'),
  QuestionScores: () => import('./slides/QuestionScoresSlide.vue'),
  Leaderboard: () => import('./slides/LeaderboardSlide.vue'),
  WHO5Breakdown: () => import('./slides/WHO5BreakdownSlide.vue'),
  Recommendations: () => import('./slides/RecommendationsSlide.vue'),
  GoalDistribution: () => import('./slides/GoalDistributionSlide.vue'),
  FocusAlignment: () => import('./slides/FocusAlignmentSlide.vue'),
  Closing: () => import('./slides/ClosingSlide.vue'),
  Empty: () => import('./slides/EmptySlide.vue')
};

const loadedSlides = {};
const asyncFactories = {};

const normalizeModule = (module) => module && (module.default || module);

export const resolveQuarterlySlideType = (type) => (
  slideLoaders[type] ? type : 'Empty'
);

export const loadQuarterlySlideComponent = async (type) => {
  const resolvedType = resolveQuarterlySlideType(type);

  if (!loadedSlides[resolvedType]) {
    const module = await slideLoaders[resolvedType]();
    loadedSlides[resolvedType] = normalizeModule(module);
  }

  return loadedSlides[resolvedType];
};

export const preloadQuarterlySlideComponents = async (types = Object.keys(slideLoaders)) => {
  const uniqueTypes = Array.from(new Set(types.map(resolveQuarterlySlideType)));
  await Promise.all(uniqueTypes.map(loadQuarterlySlideComponent));
};

export const getQuarterlySlideComponent = (type) => {
  const resolvedType = resolveQuarterlySlideType(type);

  if (loadedSlides[resolvedType]) {
    return loadedSlides[resolvedType];
  }

  if (!asyncFactories[resolvedType]) {
    asyncFactories[resolvedType] = () => loadQuarterlySlideComponent(resolvedType);
  }

  return asyncFactories[resolvedType];
};
